<template>
  <v-container fluid class="rank-wrapper ma-0">
    <v-row class="px-3" justify="center" align="stretch">
      <v-col cols="8" class="pa-0 question-wrapper">
        <div class="font-weight-medium display-16-12">
          עד כמה המשרה מעניינת אותך?
        </div>
        <div class="display-12 hidden-sm-and-down">
          תשובתך תסייע לנו לקרב אותך אל משרת חלומותייך
        </div>
      </v-col>
      <v-col cols="4" class="pa-0 d-flex button-wrapper">
        <v-btn
          class="text-center rank-button"
          depressed
          v-for="(icon, index) in icons"
          :key="index"
          height="32px"
          :loading="loading"
          @click="rankSelected(index)"
          :class="[index == selectedRank - 1 ? 'selected' : '']"
        >
          <v-icon
            right
            dark
            primary--color
            ma-0
            color="primary"
            class="rank-icon"
            :class="[index == selectedRank - 1 ? 'selected' : '']"
          >
            {{ getIcon(index) }}
          </v-icon>
          <span class="rank-text">{{ textStatus[index] }}</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="mt-3 alert-containter">
        <v-alert
          :value="displayUserMessage"
          color="#ff7100"
          dark
          normal
          transition="scale-transition"
          class="user-message-alert display-16-12"
        >
          {{ message }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Icon from '@/components/Wrappers/Icon/Icon';
import gtm from '@/lib/gtm';

export default {
  components: { Icon },
  data() {
    return {
      icons: ['icon-shape-1-5', 'icon-shape-1-4', 'icon-shape-1-3'],
      userMessage: [
        'אחלה בחירה! המשרה הועברה למשרות שאהבת',
        'רוצה לחשוב על זה? המשרה הועברה למשרות שאהבת',
        'לא אהבת? המשרה הועברה למשרות שהסרת',
      ],
      gtmStatus: ['happy', 'natural', 'sad'],
      textStatus: ['מאוד', 'קצת', 'מחק'],
      loading: false,
      displayUserMessage: false,
      message: '',
      timer: null,
    };
  },

  props: {
    rankTopic: {
      type: Object,
      required: false,
      default: () => {},
    },
    jobCode: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['JobRank']),

    selectedRank() {
      return this.JobRank(this.jobCode);
    },
  },
  methods: {
    ...mapActions({
      updateJobBasket: 'updateJobBasket',
    }),
    rankSelected(index) {
      this.loading = true;
      this.displayUserMessage = false;
      clearTimeout(this.timer);

      const isRemoved = this.selectedRank == index + 1;

      let postdata = {
        JobCodes: new Array(1).fill(this.jobCode),
        Status: index + 1,
        IsRemove: isRemoved,
      };

      this.updateJobBasket(postdata).then(() => {
        this.loading = false;
        if (!isRemoved) {
          this.setUserMessage(index + 1);
        }

        //removing from numOfJobs (before page update)
        if (index == 2) this.$nuxt.$emit('reduceNumOfJobs');

        // gtm events
        gtm({
          action: this.gtmStatus[index], // type ,
          label: 'personal area ', //  מיקום הסמיילי באתר
          category: 'smiley',
          event: 'smiley',
        });
      });
    },

    getIcon(index) {
      return this.icons[index];
    },

    setUserMessage(index) {
      this.displayUserMessage = true;
      this.message = this.userMessage[index - 1];

      this.timer = setTimeout(() => {
        this.displayUserMessage = false;
      }, 2000);
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.rank-wrapper {
  height: 60px;
  box-shadow: 0px 3px 7px 0 rgba(0, 0, 0, 0.2);
  background-color: #f6f7f9;
  place-items: center;
  line-height: 1;
}

.v-icon--right {
  margin: 0 !important;
}

button {
  border: 1px solid #e1e1e1;
  background: #f2f2f2;
}

.question-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.button-wrapper {
  justify-content: flex-end;
}
.rank-button {
  margin: 0 1px;
  width: 35px !important;
  min-width: 35px !important;
  max-width: 35px !important;
}

.rank-button.selected {
  background: $primary !important;
}

.rank-icon.selected {
  color: white !important;
}
.alert-containter {
  display: flex;
  justify-content: center;
}

.v-alert.user-message-alert.v-sheet.theme--dark,
.user-message-alert {
  color: white;
}

.theme--light.v-btn.v-btn--disabled.rank-button.selected {
  background-color: $primary !important;
}
.rank-text {
  position: absolute;
  bottom: -15px;
  color: $primary;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
}

@media screen and (max-width: 959px) {
  .rank-wrapper {
    max-width: 320px;
  }
}

@media screen and (max-width: 768px) {
  .rank-wrapper {
    max-width: 320px;
  }
}
</style>
